import { ServiceBase } from "../../models/Service";
import { BadgeProps, BaseBadge } from "./BaseBadge";

export function CriticalityScoreBadge(props: BadgeProps<ServiceBase>) {
    const content = props.textOverride ?? props?.ressource?.criticality_score?.toFixed(1)
    return <BaseBadge {...props} content={<>{content}</>} tooltip={content} />
}